/* DegenDalt quick add — adds items via /cart/add.js, then hands the response to
   Dawn's own cart-drawer.renderContents() so the drawer render + scroll-lock +
   overlay-close all stay correct. Guarded so it initialises exactly once even
   though several sections each include this script. */
(function () {
  if (window.__degenCartInit) return;   // this file is included by ~6 sections
  window.__degenCartInit = true;

  // Defensive: never let a stuck scroll-lock freeze the whole site.
  function unlockBody() {
    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  }

  window.degenAddToCart = function (items, button) {
    if (window.__degenAdding) return Promise.resolve(null); // in-flight guard → no double-add
    window.__degenAdding = true;
    if (button) {
      button.setAttribute('disabled', 'disabled');
      button.dataset.originalText = button.dataset.originalText || button.textContent;
      button.textContent = 'Dealing…';
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'Could not add to bag');
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          // Dawn handles the section swap (no nesting), overlay rebind and open().
          drawer.renderContents(data);
          // renderContents only clears is-empty on .drawer__inner; this theme puts
          // the class on <cart-drawer> itself, so the empty state (hidden header +
          // centered empty grid) kept showing over the real items. Clear it here,
          // exactly like Dawn's own product-form flow does.
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        } else if (data.sections && data.sections['cart-icon-bubble']) {
          // No drawer on the page (e.g. cart page) — just refresh the bag count.
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var el = parsed.getElementById('cart-icon-bubble') || parsed.querySelector('.shopify-section');
            if (el) bubble.innerHTML = el.innerHTML;
          }
        }
      })
      .catch(function (err) {
        unlockBody(); // a failed add must never leave the page greyed-out/frozen
        window.degenToast((err && err.message) || 'Could not add to bag');
      })
      .finally(function () {
        window.__degenAdding = false;
        if (button) {
          button.removeAttribute('disabled');
          button.textContent = button.dataset.originalText;
        }
      });
  };

  window.degenToast = function (message) {
    var existing = document.getElementById('degen-toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = 'degen-toast';
    el.className = 'degen-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2700);
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-degen-add-variant]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.dataset.degenAddVariant, 10);
    if (!id) return;
    window.degenAddToCart([{ id: id, quantity: 1 }], btn).then(function () {
      window.degenToast('Added to your hand — the odds just improved.');
    });
  });

  /* Quick-view modals — fully delegated so markup re-rendered by the
     Section Rendering API (e.g. inside the cart drawer) keeps working. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-degen-qv-open]');
    if (opener) {
      e.preventDefault();
      var m = document.querySelector('[data-degen-qv="' + opener.dataset.degenQvOpen + '"]');
      if (m) m.hidden = false;
      return;
    }
    if (e.target.closest('[data-degen-qv-close]')) {
      var mc = e.target.closest('[data-degen-qv]');
      if (mc) mc.hidden = true;
      return;
    }
    var addBtn = e.target.closest('[data-degen-qv-add]');
    if (addBtn) {
      var modal = addBtn.closest('[data-degen-qv]');
      if (!modal) return;
      var data = JSON.parse(modal.querySelector('[data-degen-qv-data]').textContent);
      var chosen = [];
      modal.querySelectorAll('[data-degen-qv-opt]').forEach(function (s) {
        chosen[parseInt(s.dataset.degenQvOpt, 10)] = s.value;
      });
      var variant = data.variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      }) || data.variants[0];
      if (!variant || !variant.available) {
        window.degenToast('That combo is tapped out — try another option.');
        return;
      }
      window.degenAddToCart([{ id: variant.id, quantity: 1 }], addBtn).then(function () {
        modal.hidden = true;
        window.degenToast('Added to your hand — the odds just improved.');
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-degen-qv]:not([hidden])').forEach(function (m) { m.hidden = true; });
    }
  });

  /* Product-card colour swatches — click a colour to swap the card image to
     that variant's image (if one is attached) and carry the variant into the
     PDP via ?variant=. The hover image-swap logic above is untouched. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-degen-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.degen-pcard');
    if (!card) return;

    card.querySelectorAll('[data-degen-swatch]').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });

    // Swap the card image to the chosen colour's image (when one exists).
    var img = card.querySelector('.degen-pcard__media img');
    var newSrc = sw.dataset.img;
    if (img && newSrc) {
      img.removeAttribute('srcset');
      img.src = newSrc;
      if ('degenFrontSrc' in img.dataset) {
        img.dataset.degenFrontSrc = newSrc;      // hover-out returns to this colour
        img.removeAttribute('data-degen-front-srcset');
      }
    }

    // Persist the colour into the PDP: append ?variant= to every product link.
    var vid = sw.dataset.variant;
    if (vid) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.origin);
          u.searchParams.set('variant', vid);
          a.setAttribute('href', u.pathname + u.search);
        } catch (err) {}
      });
    }
  });

  /* Hover alternate view — swap the single card image's src/srcset.
     Only wired when data-degen-swap exists (i.e. the product has a second
     image). Alternates preload as cards approach the viewport so the first
     swap doesn't flash. */
  function degenSwap(card, toAlt) {
    var img = card.querySelector('[data-degen-swap]');
    if (!img) return;
    var src = toAlt ? img.dataset.degenAltSrc : img.dataset.degenFrontSrc;
    var srcset = toAlt ? img.dataset.degenAltSrcset : img.dataset.degenFrontSrcset;
    if (!src) return;
    if (srcset) img.srcset = srcset;
    img.src = src;
  }
  // Hover swap is for mouse/pen only. On touch, pointerover fires on a plain
  // tap (and while scrolling), which used to flip the card image unexpectedly —
  // so touch pointers are ignored here and handled by the touch handler below.
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var card = e.target.closest('.degen-pcard');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    degenSwap(card, true);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch') return;
    var card = e.target.closest('.degen-pcard');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    degenSwap(card, false);
  });

  /* Touch: advance the card image on press-down and KEEP it on release — it only
     changes again on the next touch. The listener is passive and there is no
     touch-action override anywhere, so native horizontal scrolling of the rails
     (and vertical page scroll) is completely untouched; the image change is not
     tied to scroll movement at all. */
  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest('.degen-pcard');
    if (!card || !card.querySelector('[data-degen-swap]')) return;
    var showingAlt = card.dataset.degenTouchAlt === '1';
    degenSwap(card, !showingAlt);          // swap to the "other" image
    card.dataset.degenTouchAlt = showingAlt ? '' : '1';
  }, { passive: true });

  function degenPreloadAlts() {
    var imgs = document.querySelectorAll('[data-degen-swap]:not([data-degen-preload])');
    if (!imgs.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var pre = new Image();
          var srcset = entry.target.dataset.degenAltSrcset;
          if (srcset) pre.srcset = srcset;
          pre.src = entry.target.dataset.degenAltSrc;
        });
      }, { rootMargin: '300px' });
      imgs.forEach(function (img) {
        img.dataset.degenPreload = '1';
        io.observe(img);
      });
    } else {
      imgs.forEach(function (img) {
        img.dataset.degenPreload = '1';
        var pre = new Image();
        pre.src = img.dataset.degenAltSrc;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', degenPreloadAlts);
  else degenPreloadAlts();
})();
